import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CheckBox from '../checkBox/CheckBox';
import styles from './participatingOrgSearchItem.module.scss';

const ParticipatingOrgSearchItem = props => {
  const dispatch = useDispatch();

  const getLink = o => {
    return o.moreDetails.indexOf('href=') > -1 && o.moreDetails.indexOf('target') > -1
      ? o.moreDetails.substring(
          o.moreDetails.indexOf('href=') + 6,
          o.moreDetails.indexOf('target') - 2
        )
      : null;
  };

  return (
    <div className={styles.accordionContainer} key={props.category}>
      <div>
        {props.categoryArray.map(item => (
          <div className={styles.checkboxContainer}>
            <div className={`d-flex ${styles.orgLogo}`}>
              <a
                className={styles.imageDesc}
                onClick={() => {
                  let newSelectedOrgs = props.selectedNotifiableOrganisations.concat({
                    value: item.orgId,
                    label: item.displayName,
                    category: item.category,
                    orderByCategory: item.orderByCategory,
                    sector: item.sector,
                    logo: item.logo,
                    policyNumber: item.orgReferenceList ? [''] : [],
                    orgReferenceList: item.orgReferenceList,
                  });
                  const isSelected = props.selectedNotifiableOrganisations.find(
                    sv => sv.value === item.orgId
                  );
                  if (!isSelected) {
                    props.clearError('participatingOrganisations');
                    props.setSelectedOrganisations(newSelectedOrgs);
                    dispatch(
                      props.setIsAwareSubsidiaryShown(
                        props.filterIsAwareSuperSubsidiariesSelected(newSelectedOrgs)
                      )
                    );
                  }

                  props.setSearchByName('');
                }}
                translate="no"
              >
                {item.displayName}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ParticipatingOrgSearchItem;
